const {observable} = require("mobx");
const axios = require("axios");
const {reportAndThrow} = require("helpers/errors");
const assign = require("object-assign");
const {queryObject, setValueByQuery} = require("helpers/object");

class EntityStore {

	@observable attributes = {};

	constructor(attributes = {}, options = {}) {
		this.attributes = attributes;
		this.options = options;
	}

	get endpoint() {
		return this.options.endpoint;
	}

	get(query, defaultValue = null) {
		return queryObject(this.attributes, query, defaultValue);
	}

	set(query, value) {
		setValueByQuery(this.attributes, query, value);
		return this;
	}

	exists() {
		return this.attributes.id != undefined;
	}

	save(attributes = null, options = {}) {
		if (!this.exists()) {
			throw new Error("Cannot save entity store because the entity does not exist!");
		}

		return axios.post(this.endpoint, attributes || this.attributes, options)
			.then(response => {
				assign(this.attributes, response.data);
				return this;
			})
			.catch(reportAndThrow);
	}

}

module.exports = EntityStore;


// WEBPACK FOOTER //
// ./resources/js/stores/abstract/EntityStore.js